import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { supabase } from "../../supabase";
import { getStreak } from "../../functions/getStreak"; 
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import ClickFlower from "../../components/common/ClickFlower/ClickFlower";
import Flower from "../../components/common/Flower/Flower";
import AddWords from "../../components/AddWords";
export default function OnlineAddWords(){
const { id } = useParams(); 
const [project, setProject] = useState(null);
const [streak, setStreak] = useState(0);
const today = new Date().toISOString().split("T")[0];

useEffect(() => {
    async function fetchProject() {
      const { data, error } = await supabase
        .from("projects")
        .select("*")
        .eq("id", id)
        .single();

      if (error) {
        console.error(error);
        return;
      }
      setProject(data);
      setStreak(getStreak(data.history));
    }

    fetchProject();
}, [id]);

async function UpdateData(project) {
    const { data, error } = await supabase
      .from("projects")
      .update({
        actualwords: project.actualwords,
        history: project.history,
      })
      .eq("id", project.id);

    if (error) {
      console.error(error);
      return;
    }
  }

const addwords = async (e) => {
    e.preventDefault();
    
    const newWords = parseInt(e.target.newWords.value, 10);
    const date = e.target.dateWords.value;
    const kopia = { ...project, history: [...project.history] };
    const Variant = e.target.Variant.value;
    let wordsCount;
    if(Variant == 'add'){
          wordsCount = newWords;
    } else if (Variant == 'set')  {
          const AllWords = kopia.actualwords;
          wordsCount = newWords - AllWords;
    }

    if (date > today) {
      alert("Umiesz przewidywać przyszłość? 🤨");
      return;
    }
    kopia.actualwords += wordsCount;

    const existing = kopia.history.find((entry) => entry.date === date);

    if (existing) existing.words += wordsCount;
    else kopia.history.push({ date, words: wordsCount });

    kopia.history.sort((a, b) => new Date(a.date) - new Date(b.date));
    setProject(kopia);
    setStreak(getStreak(kopia.history));
    e.target.newWords.value = "";

    UpdateData(kopia);
  };

  const updateProject = async (updatedProject) => {
    setProject(updatedProject);

    const { error } = await supabase
        .from("projects")
        .update(updatedProject)
        .eq("id", id);

    if (error) {
        console.error(error);
    }
};

    return (
      <div className="projectlist-wrapper">
      <ProjectHeader
          headerTitle = {project?.title}
          showBackButton = {true}
          path={`/online/project/${id}`}
      />

      {/*<div className="SettingsForm" style={{marginTop: '100px'}}>
        <form onSubmit={AddWords}>
              <label>
                Dodaj słowa
                <input type="number" name="newWords" required className="chapterInput" />
              </label>

              <label>
                Data
                <input type="date" name="dateWords" required className="chapterInput" defaultValue={today} />
              </label>

            <select name = "Variant" className="chapterInput"> 
            <option value='add'> Nowe słowa </option>
            <option value='set'> Cały projekt </option>
            </select>
            <button>Dodaj słowa</button>
        </form>

      </div>*/}

      <AddWords
      project={project}
      updateProject={updateProject}/>

        <Flower
        flowerClass={"flower1"}/>
        <Flower
        flowerClass={"flower2"}/>
        <ClickFlower/>
      </div>
    )
}